"use client";

import { useMemo } from "react";
import type {
  SelectedThought,
  SelectedThoughtFree,
  Target,
} from "@/generated/fastapi";
import useStudioArrangementState from "./useStudioArrangementState";

export default function useStudioFreeListArrangement({
  selectedThoughtsFree,
  rerankTarget,
  scopeKey,
}: {
  selectedThoughtsFree: SelectedThoughtFree[];
  rerankTarget?: Target | null | undefined;
  scopeKey: string;
}) {
  const syntheticSelectedThoughts = useMemo<SelectedThought[]>(
    () =>
      selectedThoughtsFree.map((selection) => ({
        prototype: selection.prototype,
        situation_id: null,
        thoughts_ids: selection.thoughts_ids,
      })),
    [selectedThoughtsFree],
  );

  const sourceKeyPayload = useMemo(
    () => ({
      selectedThoughtsFree: selectedThoughtsFree.map((selection) => ({
        prototype: selection.prototype,
        thoughts_ids: selection.thoughts_ids,
      })),
    }),
    [selectedThoughtsFree],
  );

  return useStudioArrangementState({
    selectedThoughts: syntheticSelectedThoughts,
    rerankTarget,
    scopeKey,
    sourceKeyPayload,
  });
}
